import axios from "axios";
import { serverData, serviceUrls } from "./constant.js";
import {
  get,
  post,
  put,
  del,
  createQueryParams,
  getLocalStorageData,
} from "./axiosComponent.js";
export const getCountryList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/open/system/country/list",
    params: createQueryParams(data),
  });
};

export const getCityList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/open/system/city/list",
    params: createQueryParams(data),
  });
};

export const getStateList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/open/system/state/list",
    params: createQueryParams(data),
  });
};
